<template lang="pug">
div.flex.min-h-screen.justify-center.bg-white
	.w-full.max-w-5xl.mt-32

		.flex.align-center.font-medium
			router-link.flex.align-center(to="/")
				span Dashboard
			router-link.flex.align-center(:to="'/key-result?kr=' + parent.id" v-if="parentIsKeyResult") 
				span.opacity-25.mx-2.font-bold /
				span {{parent.title}}
			p.flex.align-center.text-gray-6
				span.opacity-25.mx-2.font-bold /
				span {{keyResult.title}}

		KeyResult.mt-6(v-if="parent" :parent="parent" :isNested="parentIsKeyResult" :keyResultId="keyResultId" size="lg" @rejig="setup")

		div.h-32
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import { mapGetters } from "vuex";
import KeyResult from "../components/KeyResult";
import Modal from "../templates/Modal";

export default {
  components: { KeyResult, Modal },
  data() {
    return {
      keyResultId: "",
      keyResult: null,
      showCreateModal: false,
      modalInner: "KeyResult"
    };
  },
  created() {
    this.setup();
  },
  computed: {
    ...mapGetters([
      "profile",
      "company",
      "gettingObjectives",
      "isSigningIn",
      "gettingCompany",
      "objectives",
      "keyResults"
    ]),
    parentIsKeyResult() {
      return this.keyResults.some(kr => kr.id == this.keyResult.parent);
    },
    parent() {
      const obj = this.objectives.find(obj => obj.id == this.keyResult.parent);
      const keyr = this.keyResults.find(kr => kr.id == this.keyResult.parent);

      if (obj) return obj;
      else return keyr;
    }
  },
  methods: {
    setup() {
      var id = this.$route.query.kr;

      if (id) {
        this.keyResultId = id;
        this.keyResult = this.keyResults.find(kr => kr.id == id);
      } else this.$router.push("/");
    },
    checkParentKr() {
      return this.keyResults.find(kr => kr.id == this.keyResult.parent);
    },
    checkParentObj() {
      return this.objectives.find(obj => obj.id == this.keyResult.parent);
    }
  },
  watch: {
    $route() {
      if (this.$route.query.kr != this.keyResultId) this.setup();
    }
  }
};
</script>

<style lang="sass">
.tab
  margin-top: 2px
</style>
